import { render, staticRenderFns } from "./pondConsumeRecordList.vue?vue&type=template&id=38895b53&scoped=true&"
import script from "./pondConsumeRecordList.vue?vue&type=script&lang=js&"
export * from "./pondConsumeRecordList.vue?vue&type=script&lang=js&"
import style0 from "./pondConsumeRecordList.vue?vue&type=style&index=0&id=38895b53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38895b53",
  null
  
)

export default component.exports